import { TextCollectionField } from '@scale/shared/types/params/textcollection';
import { TextCollectionAnnotation } from '@scale/shared/types/response/textcollection';
import { getFieldSetCounts, FieldSetCount } from './fieldSetUtils';
import {
  Breadcrumb,
  getCurrentFields,
  getCurrentAnnotations,
  getBreadcrumbTitle,
} from './breadcrumbs';

// @ts-ignore import JavaScript package
import pluralize from 'pluralize';

export function getDeleteMessage(
  fields: TextCollectionField[],
  annotations: Record<string, TextCollectionAnnotation>,
  focus: Breadcrumb[],
): string {
  const title = getBreadcrumbTitle(fields, annotations, focus);
  const fieldSetCounts = getFieldSetCounts(
    getCurrentFields(fields, focus).fields,
    getCurrentAnnotations(annotations, focus).annotations,
  );
  const message = [
    `Are you sure you want to delete "${title}"?`,
    getChildFieldSetConfirmMessage(fieldSetCounts),
  ]
    .filter(str => str.length)
    .join(' ');
  return message;
}

function getChildFieldSetConfirmMessage(fieldSetCounts: FieldSetCount[]): string {
  const nonZeroFieldSetCounts = fieldSetCounts.filter(fieldSetCount => fieldSetCount.count > 0);
  const titles = nonZeroFieldSetCounts.map(fieldSetCount => {
    return pluralize(fieldSetCount.title.toLowerCase(), 2, false);
  });
  if (!titles.length) {
    return '';
  }
  const prefix = 'This will also delete its ';
  const suffix = '.';
  return prefix + fancyJoinLast(titles, ', ', ' and ') + suffix;
}

function fancyJoinLast(strings: string[], sep: string, lastSep: string): string {
  if (strings.length === 0) {
    return '';
  }
  if (strings.length === 1) {
    return strings[0];
  }
  return strings.slice(0, strings.length - 1).join(sep) + lastSep + strings[strings.length - 1];
}
